import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/7c680545/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import { StructuredListWrapper, StructuredListHead, StructuredListBody, StructuredListRow, StructuredListInput, StructuredListCell, OrderedList, ListItem } from 'carbon-components-react';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PageDescription mdxType="PageDescription">
      <p>{`The Checkbox React Carbon Component has been tested against the latest `}<a parentName="p" {...{
          "href": "https://www.w3.org/TR/WCAG21/"
        }}>{`W3C
Web Content Accessibility Guidelines (WCAG) 2.1 Level A and AA success
criteria`}</a>{` and violations have been identified
as high priority issues. This document will be updated when these
accessibility issues are resolved.`}</p>
    </PageDescription>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">How it works</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Accessibility considerations</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Resources</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Accessibility testing</AnchorLink>
    </AnchorLinks>
    <h2 {...{
      "id": "how-it-works"
    }}>{`How it works`}</h2>
    <p>{`The Checkbox Component is used to provide a list of options where the user can select multiple options, including all or none. A checkbox control has three possible states indicated by the value of its aria-checked attribute, “true” when selected, “false” when unselected and “mixed” when in the indeterminate state. The indeterminate state comes into play when the checkbox contains a sublist of selections, some of which are selected, and some unselected.`}</p>
    <p>{`The Tab key is used to move focus to each checkbox. Checkboxes identified as disabled are ignored in the tab order. The Space key is used to select and deselect each checkbox when the checkbox has focus. When the checkbox is selected the ARIA state is set to aria-checked=“true” and when it is deselected aria-checked=“false”. An indeterminable checkbox has an ARIA state that is set to aria-checked=“mixed” until it is selected or deselected by the user. Fieldset and Legend elements are used for labeling the checkbox group.`}</p>
    <h2 {...{
      "id": "accessibility-considerations"
    }}>{`Accessibility considerations`}</h2>
    <p>{`This component has been validated to meet the `}<a parentName="p" {...{
        "href": "https://www.w3.org/TR/WCAG20/"
      }}>{`WCAG 2.0 AA`}</a>{` and `}<a parentName="p" {...{
        "href": "http://www.section508.gov/"
      }}>{`Section 508`}</a>{` accessibility guidelines, however changes made by the content owner can affect accessibility compliance. Be sure to review and follow the guidance in this section when updating or adding new content to this component.`}</p>
    <ol>
      <li parentName="ol">{`Checkboxes must have a clear and concise label.`}</li>
      <li parentName="ol">{`Users should be warned if selecting a checkbox will cause a change in context.`}</li>
      <li parentName="ol">{`If the checkbox is a required field include the `}<a parentName="li" {...{
          "href": "https://www.w3.org/TR/WCAG20-TECHS/ARIA2.html"
        }}>{`aria-required property`}</a>{` and indicate that it is a required field and use the validation message for input errors.`}</li>
    </ol>
    <h2 {...{
      "id": "resources"
    }}>{`Resources`}</h2>
    <p><strong parentName="p">{`Helpful resources for creating customized accessible implementations`}</strong></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.w3.org/TR/wai-aria-practices/examples/checkbox/checkbox-1/checkbox-1.html"
        }}>{`W3C WAI-ARIA Authoring Practices Checkbox Design Pattern`}</a>{` covers the usage of ARIA names, state and roles, as well as the expected keyboard intractions.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.ibm.com/able/guidelines/ci162/accessibility_checklist.html"
        }}>{`IBM Accessibility Checklist Checkpoint:`}</a><ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://www.ibm.com/able/guidelines/ci162/info_and_relationships.html"
            }}>{`1.3.1 Information and Relationships`}</a>{` (WCAG Success Criteria `}<a parentName="li" {...{
              "href": "https://www.w3.org/TR/2016/NOTE-UNDERSTANDING-WCAG20-20161007/content-structure-separation-programmatic.html"
            }}>{`1.3.1`}</a>{`)`}</li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://www.ibm.com/able/guidelines/ci162/labels_or_instructions.html"
            }}>{`3.3.2 Labels and Instructions`}</a>{` (WCAG Success Criteria `}<a parentName="li" {...{
              "href": "https://www.w3.org/TR/UNDERSTANDING-WCAG20/minimize-error-cues.html"
            }}>{`3.3.2`}</a>{`)`}</li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://www.ibm.com/able/guidelines/ci162/name_role_value.html"
            }}>{`4.1.2 Name, Role, Value`}</a>{` (WCAG Success Criteria `}<a parentName="li" {...{
              "href": "https://www.w3.org/WAI/WCAG21/Understanding/name-role-value"
            }}>{`4.2.1`}</a>{`)`}</li>
        </ul></li>
    </ul>
    <h2 {...{
      "id": "accessibility-testing"
    }}>{`Accessibility testing`}</h2>
    <h3 {...{
      "id": "automated-test"
    }}>{`Automated test`}</h3>
    <Row mdxType="Row">
  <Column noGutterSm mdxType="Column">
    <StructuredListWrapper mdxType="StructuredListWrapper">
      <StructuredListHead mdxType="StructuredListHead">
        <StructuredListRow head mdxType="StructuredListRow">
          <StructuredListCell head mdxType="StructuredListCell">
            Automated test environment
          </StructuredListCell>
          <StructuredListCell head mdxType="StructuredListCell">Results</StructuredListCell>
        </StructuredListRow>
      </StructuredListHead>
      <StructuredListBody mdxType="StructuredListBody">
        <StructuredListRow mdxType="StructuredListRow">
          <StructuredListCell mdxType="StructuredListCell">
            - macOS Mojave version 10.14.6 with VoiceOver
            <br />
            - Chrome Version 77.0.3865.90
            <br />
            - Dynamic Assessment Plugin Version 1.8.0.0 - IBM Accessibility WCAG
            2.1 Sept. 2019 Ruleset
            <br />- Carbon React Version 7.7.1
          </StructuredListCell>
          <StructuredListCell mdxType="StructuredListCell">
            <strong>DAP Test</strong>
            <br />- No violations
          </StructuredListCell>
        </StructuredListRow>
      </StructuredListBody>
    </StructuredListWrapper>
  </Column>
    </Row>
    <h3 {...{
      "id": "macos-screen-reader-tests"
    }}>{`macOS Screen reader tests`}</h3>
    <Row mdxType="Row">
  <Column noGutterSm mdxType="Column">
    <StructuredListWrapper mdxType="StructuredListWrapper">
      <StructuredListHead mdxType="StructuredListHead">
        <StructuredListRow head mdxType="StructuredListRow">
          <StructuredListCell head mdxType="StructuredListCell">Environment </StructuredListCell>
          <StructuredListCell head mdxType="StructuredListCell">Results</StructuredListCell>
        </StructuredListRow>
      </StructuredListHead>
      <StructuredListBody mdxType="StructuredListBody">
        <StructuredListRow mdxType="StructuredListRow">
          <StructuredListCell mdxType="StructuredListCell">
            - macOS Mojave version 10.14.6 with VoiceOver
            <br />
            - Chrome Version 77.0.3865.90
            <br />- Carbon React Version 7.7.1
          </StructuredListCell>
          <StructuredListCell mdxType="StructuredListCell">
            <strong>VoiceOver(VO) Test:</strong>
            <OrderedList mdxType="OrderedList">
              <ListItem mdxType="ListItem">
                Press the Tab key to navigate to the first checkbox. VO
                announces the label, the state as checked, that it is a checkbox
                input and the label group.
              </ListItem>
              <ListItem mdxType="ListItem">
                Press the Space key to select or deselect the checkbox.
              </ListItem>
              <ListItem mdxType="ListItem">
                Press the Tab key to navigate to the indeterminable checkbox. VO
                announces the label, and the state as mixed.
              </ListItem>
              <ListItem mdxType="ListItem">
                Press the Space key to select or deselect the checkbox.
              </ListItem>
              <ListItem mdxType="ListItem">
                Press the Tab key and the disabled checkbox is skipped.
              </ListItem>
              <ListItem mdxType="ListItem">
                Control-Option-Left Arrow key to read the disabled field. VO
                announces, "Disabled checkbox, dimmed unchecked checkbox".
              </ListItem>
              <ListItem mdxType="ListItem">
                Tab to the next group of checkboxes with the same results.
              </ListItem>
            </OrderedList>
          </StructuredListCell>
        </StructuredListRow>
        <StructuredListRow mdxType="StructuredListRow">
          <StructuredListCell mdxType="StructuredListCell">
            - macOS Mojave version 10.14.6 with VoiceOver
            <br />
            - Safari Version 13.0.2
            <br />- Carbon React Version 7.7.1
          </StructuredListCell>
          <StructuredListCell mdxType="StructuredListCell">
            <strong>VoiceOver(VO) Test:</strong>
            <OrderedList mdxType="OrderedList">
              <ListItem mdxType="ListItem">
                Press the Tab key to navigate to the first checkbox. VO
                announces the label, the state as checked, the checkbox legend
                and the group.
              </ListItem>
              <ListItem mdxType="ListItem">
                Press the Space key to select or deselect the checkbox.
              </ListItem>
              <ListItem mdxType="ListItem">
                Press the Tab key to navigate to the indeterminable checkbox. VO
                announces the label, and the state as unchecked (Note: The mixed
                state is not announced).
              </ListItem>
              <ListItem mdxType="ListItem">
                Press the Space key to select or deselect the checkbox.
              </ListItem>
              <ListItem mdxType="ListItem">
                Press the Tab key and the disabled checkbox is skipped.
              </ListItem>
              <ListItem mdxType="ListItem">
                Control-Option-Left Arrow key to read the disabled field. VO
                announces, "Off off dimmed unchecked checkbox".
              </ListItem>
              <ListItem mdxType="ListItem">
                Tab to the next group of checkboxes with the same results.
              </ListItem>
            </OrderedList>
          </StructuredListCell>
        </StructuredListRow>
      </StructuredListBody>
    </StructuredListWrapper>
  </Column>
    </Row>
    <h3 {...{
      "id": "windows-screen-reader-tests"
    }}>{`Windows screen reader tests`}</h3>
    <Row mdxType="Row">
  <Column noGutterSm mdxType="Column">
    <StructuredListWrapper mdxType="StructuredListWrapper">
      <StructuredListHead mdxType="StructuredListHead">
        <StructuredListRow head mdxType="StructuredListRow">
          <StructuredListCell head mdxType="StructuredListCell">Environment</StructuredListCell>
          <StructuredListCell head mdxType="StructuredListCell">Results</StructuredListCell>
        </StructuredListRow>
      </StructuredListHead>
      <StructuredListBody mdxType="StructuredListBody">
        <StructuredListRow mdxType="StructuredListRow">
          <StructuredListCell mdxType="StructuredListCell">
            - Microsoft Windows 10
            <br />
            - Firefox Version 67
            <br />
            - JAWS 19.1810.64
            <br />- Carbon React Version 7.7.1
          </StructuredListCell>
          <StructuredListCell mdxType="StructuredListCell">
            <strong>JAWS test:</strong>
            <OrderedList mdxType="OrderedList">
              <ListItem mdxType="ListItem">
                Navigate among check boxes by pressing the Tab and Shift-Tab
                keys, or X and Shift+X keys to jump to next or previous
                checkboxes.
              </ListItem>
              <ListItem mdxType="ListItem">
                When navigating to a checkbox, JAWS announces the label,
                checkbox, and the status of the checkbox.
              </ListItem>
              <ListItem mdxType="ListItem">
                Disabled checkboxes can only be found by using the Up and Down
                Arrow keys, when JAWS.
              </ListItem>
              <ListItem mdxType="ListItem">
                Press the Space key to select or deselect the checkbox. JAWS
                announces the status of checked or unchecked.
              </ListItem>
            </OrderedList>
          </StructuredListCell>
        </StructuredListRow>
        <StructuredListRow mdxType="StructuredListRow">
          <StructuredListCell mdxType="StructuredListCell">
            - Microsoft Windows 10
            <br />
            - Chrome Version 73.0.3683.103 (Official Build) (64-bit)
            <br />
            - JAWS Version 19.1810.64
            <br />- Carbon React Version 7.7.1
          </StructuredListCell>
          <StructuredListCell mdxType="StructuredListCell">
            <strong>JAWS test:</strong>
            <OrderedList mdxType="OrderedList">
              <ListItem mdxType="ListItem">
                Navigate among check boxes by pressing the Tab and Shift-Tab
                keys, or X and Shift+X keys to jump to next or previous
                checkboxes.
              </ListItem>
              <ListItem mdxType="ListItem">
                When navigating to a checkbox, JAWS announces the label,
                checkbox, and the status of the checkbox.
              </ListItem>
              <ListItem mdxType="ListItem">
                Disabled checkboxes can only be found by using the Up and Down
                Arrow keys, when JAWS announces "disabled checkbox checkbox
                unchecked unavailable".
              </ListItem>
              <ListItem mdxType="ListItem">
                Press the Space key to select or deselect the checkbox. JAWS
                announces the status of checked or unchecked.
              </ListItem>
            </OrderedList>
          </StructuredListCell>
        </StructuredListRow>
        <StructuredListRow mdxType="StructuredListRow">
          <StructuredListCell mdxType="StructuredListCell">
            - Microsoft Windows 10
            <br />
            - Chrome Version 73.0.3683.103 (Official Build) (64-bit)
            <br />
            - NVDA Version 2018.4.1
            <br />- Carbon React Version 7.7.1
          </StructuredListCell>
          <StructuredListCell mdxType="StructuredListCell">
            <strong>NVDA test:</strong>
            <OrderedList mdxType="OrderedList">
              <ListItem mdxType="ListItem">
                Navigate among check boxes by pressing the Tab and Shift-Tab
                keys, or X and Shift+X keys to jump to next or previous
                checkboxes.
              </ListItem>
              <ListItem mdxType="ListItem">
                When navigating to a checkbox, NVDA announces the label,
                checkbox, and the status of the checkbox, but repeats the
                information twice.
              </ListItem>
              <ListItem mdxType="ListItem">
                When navigating to an indeterminable checkbox NVDA announces,
                "indeterminate checkbox indeterminate checkbox checkbox half
                checked".
              </ListItem>
              <ListItem mdxType="ListItem">
                Disabled checkboxes can only be found by using the Up and Down
                Arrow keys, or the the X and Shift+X keys. NVDA announces
                "checkbox unavailable not checked disabled checkbox".
              </ListItem>
              <ListItem mdxType="ListItem">
                Press the Space or Enter key to select or deselect the checkbox.
                NVDA announces the status of checked or unchecked.
              </ListItem>
            </OrderedList>
          </StructuredListCell>
        </StructuredListRow>
      </StructuredListBody>
    </StructuredListWrapper>
  </Column>
    </Row>
    <h3 {...{
      "id": "android-screen-reader-tests"
    }}>{`Android screen reader tests`}</h3>
    <Row mdxType="Row">
  <Column noGutterSm mdxType="Column">
    <StructuredListWrapper mdxType="StructuredListWrapper">
      <StructuredListHead mdxType="StructuredListHead">
        <StructuredListRow head mdxType="StructuredListRow">
          <StructuredListCell head mdxType="StructuredListCell">Environment </StructuredListCell>
          <StructuredListCell head mdxType="StructuredListCell">Results</StructuredListCell>
        </StructuredListRow>
      </StructuredListHead>
      <StructuredListBody mdxType="StructuredListBody">
        <StructuredListRow mdxType="StructuredListRow">
          <StructuredListCell mdxType="StructuredListCell">
            - Android Version 9 with Talkback
            <br />
            - Chrome Version 73.0.3683.103 (Official Build) (64-bit)
            <br />- Carbon React Version 7.7.1
          </StructuredListCell>
          <StructuredListCell mdxType="StructuredListCell">
            <strong>Talkback Test:</strong>
            <OrderedList mdxType="OrderedList">
              <ListItem mdxType="ListItem">
                Navigate to the checkbox by swiping left or right, or press the
                Left or Right Arrow keys. Talkback announces,the label, field
                type, and the status of the checkbox.
              </ListItem>
              <ListItem mdxType="ListItem">
                The status of indeterminate checkboxes is not announced
                properly, Talkback only announces checked or unchecked.
              </ListItem>
              <ListItem mdxType="ListItem">
                When tapping on a checkbox, or pressing the Alt-Enter keys,
                Talkback announces the new status of the checkbox as checked or
                not checked.
              </ListItem>
            </OrderedList>
          </StructuredListCell>
        </StructuredListRow>
      </StructuredListBody>
    </StructuredListWrapper>
  </Column>
    </Row>
    <h3 {...{
      "id": "ios-screen-reader-tests"
    }}>{`iOS screen reader tests`}</h3>
    <Row mdxType="Row">
  <Column noGutterSm mdxType="Column">
    <StructuredListWrapper mdxType="StructuredListWrapper">
      <StructuredListRow head mdxType="StructuredListRow">
        <StructuredListCell head mdxType="StructuredListCell">Environment </StructuredListCell>
        <StructuredListCell head mdxType="StructuredListCell">Results</StructuredListCell>
      </StructuredListRow>
      <StructuredListBody mdxType="StructuredListBody">
        <StructuredListRow mdxType="StructuredListRow">
          <StructuredListCell mdxType="StructuredListCell">
            - iOS Version 13.1.3 with VoiceOver
            <br />
            - Safari Version 13.1.3
            <br />- Carbon React Version 7.7.1
          </StructuredListCell>
          <StructuredListCell mdxType="StructuredListCell">
            <strong>VoiceOver Test:</strong>
            <OrderedList mdxType="OrderedList">
              <ListItem mdxType="ListItem">
                Navigate to the checkbox by swiping left or right, or press the
                Left-Arrow or Right-Arrow keys when quick navigation is turned
                on. VO announces,the label, field type, and the status of the
                checkbox.
              </ListItem>
              <ListItem mdxType="ListItem">
                The status of indeterminate checkboxes is not announced
                properly, VoiceOver only announces checked or unchecked.
              </ListItem>
              <ListItem mdxType="ListItem">
                VoiceOver announces the beginning of the list, nesting level,
                content of the list item, the end of the list.
              </ListItem>
              <ListItem mdxType="ListItem">
                When tapping on a checkbox, or pressing VO+Space, VoiceOver
                announces the new status of the checkbox as checked or
                unchecked.
              </ListItem>
            </OrderedList>
          </StructuredListCell>
        </StructuredListRow>
      </StructuredListBody>
    </StructuredListWrapper>
  </Column>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      